import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M11 1v4H8l4 4 4-4h-3V1zM4 11h16v2H4zm4 8h3v4h2v-4h3l-4-4z"
}), 'VerticalAlignCenterTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/VerticalAlignCenterTwoTone.js
// module id = 7019
// module chunks = 2